/* global window */

import { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { reduxForm, Field, Form } from 'redux-form';

import { TextField } from 'common/components/forms';
import { FormError } from 'common/components/layout';
import { resetPassword } from 'redux/customer/actions';
import { asyncValidatePassword } from 'redux/customer/helpers';

import { validateResetPassword } from './validators';

class ResetPasswordForm extends Component {
  handleSubmit = (form) => {
    const { props } = this;
    const { resetPasswordId, emailId } = this.props;
    const data = transformData(form);
    delete data.confirmPassword;
    data.resetPasswordId = resetPasswordId;
    data.emailId = emailId;
    const successFunction = (response) => {
      if (response.redirectLink) {
        window.location.href = response.redirectLink;
      } else {
        props.history.push('/profile');
      }
    };
    props.resetPassword(data, successFunction);
  };

  render() {
    const { handleSubmit, form } = this.props;
    return (
      <>
        <Form
          onSubmit={handleSubmit(this.handleSubmit)}
          className="c7-form"
          method="post"
        >
          <FormError formName={form} />
          <Field
            name="password"
            label="Password"
            component={TextField}
            formType="password"
            required
          />
          <Field
            name="confirmPassword"
            label="Confirm Password"
            component={TextField}
            formType="password"
            required
          />
          <div>
            <button type="submit" className="c7-button">
              Reset Password
            </button>
          </div>
        </Form>
      </>
    );
  }
}

const transformData = (values) => {
  const data = {
    password: values.password,
    confirmPassword: values.confirmPassword
  };
  return data;
};

const validate = (values) => {
  const data = transformData(values);
  const errors = validateResetPassword(data);
  return errors;
};

const asyncValidate = (values) => {
  const { password } = values;
  return asyncValidatePassword(password).then((errors) => {
    if (errors) {
      throw errors;
    }
  });
};

ResetPasswordForm = reduxForm({
  form: 'resetPassword',
  enableReinitialize: true,
  onSubmitFail: (err, dispatch) => {
    dispatch({ type: 'ADD_FORM_ERROR', payload: err });
  },
  onSubmitSuccess: (result, dispatch) => {
    dispatch({ type: 'REMOVE_FORM_ERROR' });
  },
  validate,
  asyncValidate,
  asyncBlurFields: ['password']
})(ResetPasswordForm);

export default withRouter(
  connect(null, {
    resetPassword
  })(ResetPasswordForm)
);
